import { useLang } from "../lib/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden border-y border-emerald-500/20 bg-[#070A09] py-6 sm:py-8" data-testid="marquee">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {items.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-display text-4xl font-black uppercase tracking-tight sm:text-6xl">
                <span className={i % 2 ? "text-outline-green" : "text-white"}>{w}</span>
                <svg viewBox="0 0 24 24" className="mx-8 h-6 w-6 sm:mx-12 sm:h-8 sm:w-8"><path d="M12 0l3 9 9 3-9 3-3 9-3-9-9-3 9-3z" fill="#00E676" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
